 
<div class="container-fluid">
  <div class="card card-custom-h">
    <!-- begin::Body -->
    <div class="card-body">
      <form [formGroup]="AddForm"  (ngSubmit)="addHeaderTemplate()">
        <div class=" row">
          <div class="col-md-12">
            <BBSF-MultiLingualTextBox [options]="MultiLingualName" [group]="AddForm"></BBSF-MultiLingualTextBox>
          </div>
        </div>
        <div class=" row">
          <div class="col-md-12">
            <BBSF-MultiLingualHtmlEditor  [options]="MultiLingualHeader" [group]="AddForm"></BBSF-MultiLingualHtmlEditor >
          </div>
        </div>

        <div class=" row">
          <div class="col-md-12 table-dark-skin">
            <BBSF-MultiLingualHtmlEditor  [options]="MultiLingualFooter" [group]="AddForm"></BBSF-MultiLingualHtmlEditor >
            </div>
        </div>
       
        <div class=" row">
          <div class="col-md-12 ">
            <BBSF-MultiLingualHtmlEditor  [options]="MultiLingualHtmlHeadSection" [group]="AddForm"></BBSF-MultiLingualHtmlEditor >
          </div>
        </div>
        <div class=" row">
          <div class="col-md-12">
            <BBSF-MultiLingualTextBox [options]="MultiLingualHtmlHeadTagAttributes" [group]="AddForm"></BBSF-MultiLingualTextBox>

          </div>
        </div>
      </form>
    </div>
    <div class="card-footer border-0 justify-content-end d-flex">
      <button #CloseAddModal id="CloseAddModal" type="button" class="btn btn-light-primary btn-sm me-3" (click)="close()">{{utilityService.getResourceValue("CancelLabel")}}</button>
      <button type="submit" class="btn btn-primary btn-sm ">{{utilityService.getResourceValue("SaveLabel")}}</button>
    </div>
  </div>
  </div>
